import NormalDownload from './normal';
import MiniDownload from './mini';
import HkCoffeeDownload from './hk';

export default {
  NormalDownload,
  MiniDownload,
  HkCoffeeDownload,
};
